export type TestimonialItem = {
  name: string
  quote: string
  avatarSlug: string
}

export const meetIvyTestimonials: TestimonialItem[] = [
  {
    name: 'Marcus Webb',
    quote:
      "Ivy's research workflows make every answer sharper and more useful.",
    avatarSlug: 'marcus-webb',
  },
  {
    name: 'James Mitchell',
    quote:
      'Ivy makes market context easier to understand without jumping across tools.',
    avatarSlug: 'james-mitchell',
  },
  {
    name: 'Sarah Chen',
    quote:
      'The portfolio-aware answers are the unlock. It starts with what I actually hold.',
    avatarSlug: 'sarah-chen',
  },
  {
    name: 'Elena Park',
    quote:
      'I stopped tab-hopping between my broker, charts, and news. Ivy keeps it in one thread.',
    avatarSlug: 'elena-park',
  },
  {
    name: 'Jordan Lee',
    quote:
      'Options chains and portfolio risk in the same conversation — that is the difference.',
    avatarSlug: 'jordan-lee',
  },
]
